import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.getLoggedInUser().pipe(
    take(1),
    map(user => {
      if (user && user.orgCode) {
        return true;
      }
      
      console.warn('[AuthGuard] Access denied. No valid session or missing orgCode.');
      router.navigate(['/auth/login']);
      return false;
    })
  );
};
